import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isCharSequence1ju9jr1w86plq as isCharSequence,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  indexOf1xbs558u7wr52 as indexOf,
  trim11nh7r46at6sx as trim,
  contains2el4s70rdq4ld as contains,
  startsWith38d3sbg25w0lx as startsWith,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Companion_instance2m0l52cqv6ko3 as Companion_instance,
  HeaderValueWithParameters2awuza444hhll as HeaderValueWithParameters,
} from './HeaderValueWithParameters.mjs';
import {
  parseHeaderValuealpos28fgp6t as parseHeaderValue,
  HeaderValueParam1kbqez3tb3lqp as HeaderValueParam,
} from './HttpHeaderValueParser.mjs';
import {
  last1vo29oleiqj36 as last,
  plus20p0vtfmu0596 as plus,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { take9j4462mea726 as take } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Charsets_getInstance3jooo7e4x0j2x as Charsets_getInstance,
  forName2faodmskqnoz5 as forName,
  get_name2f11g4r0d5pxp as get_name,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var textSubTypes;
function hasParameter($this, name, value) {
  var tmp;
  switch ($this.g4u_1.q2()) {
    case 0:
      tmp = false;
      break;
    case 1:
      // Inline function 'kotlin.let' call

      var it = $this.g4u_1.r2(0);
      tmp = (equals(it.h4u_1, name, true) && equals(it.i4u_1, value, true));
      break;
    default:
      var tmp0 = $this.g4u_1;
      var tmp$ret$2;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.n1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$2 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (equals(element.h4u_1, name, true) && equals(element.i4u_1, value, true)) {
            tmp$ret$2 = true;
            break $l$block_0;
          }
        }
        tmp$ret$2 = false;
      }

      tmp = tmp$ret$2;
      break;
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.k4u_1 = ContentType().p4u('*', '*');
      }
      pt(value) {
        if (isBlank(value))
          return this.k4u_1;
        // Inline function 'io.ktor.http.Companion.parse' call
        var headerValue = last(parseHeaderValue(value));
        var tmp0 = headerValue.q4u_1;
        var parameters = headerValue.r4u_1;
        var slash = indexOf(tmp0, _Char___init__impl__6a9atx(47));
        if (slash === -1) {
          // Inline function 'kotlin.text.trim' call
          if (toString(trim(isCharSequence(tmp0) ? tmp0 : THROW_CCE())) === '*')
            return Companion_getInstance().k4u_1;
          throw BadContentTypeFormatException().v4u(value);
        }
        // Inline function 'kotlin.text.trim' call
        var this_0 = take(tmp0, slash);
        var type = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(type) === 0) {
          throw BadContentTypeFormatException().v4u(value);
        }
        // Inline function 'kotlin.text.trim' call
        var this_1 = substring(tmp0, slash + 1 | 0);
        var subtype = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        if (contains(type, _Char___init__impl__6a9atx(32)) || contains(subtype, _Char___init__impl__6a9atx(32))) {
          throw BadContentTypeFormatException().v4u(value);
        }
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(subtype) === 0) {
          tmp = true;
        } else {
          tmp = contains(subtype, _Char___init__impl__6a9atx(47));
        }
        if (tmp) {
          throw BadContentTypeFormatException().v4u(value);
        }
        return ContentType().p4u(type, subtype, parameters);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var ApplicationClass;
function Application() {
  if (ApplicationClass === VOID) {
    class $ {
      constructor() {
        Application_instance = this;
        this.w4u_1 = 'application';
        this.x4u_1 = ContentType().p4u('application', '*');
        this.y4u_1 = ContentType().p4u('application', 'atom+xml');
        this.z4u_1 = ContentType().p4u('application', 'cbor');
        this.a4v_1 = ContentType().p4u('application', 'json');
        this.b4v_1 = ContentType().p4u('application', 'hal+json');
        this.c4v_1 = ContentType().p4u('application', 'javascript');
        this.d4v_1 = ContentType().p4u('application', 'octet-stream');
        this.e4v_1 = ContentType().p4u('application', 'rss+xml');
        this.f4v_1 = ContentType().p4u('application', 'soap+xml');
        this.g4v_1 = ContentType().p4u('application', 'xml');
        this.h4v_1 = ContentType().p4u('application', 'xml-dtd');
        this.i4v_1 = ContentType().p4u('application', 'yaml');
        this.j4v_1 = ContentType().p4u('application', 'zip');
        this.k4v_1 = ContentType().p4u('application', 'gzip');
        this.l4v_1 = ContentType().p4u('application', 'x-www-form-urlencoded');
        this.m4v_1 = ContentType().p4u('application', 'pdf');
        this.n4v_1 = ContentType().p4u('application', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        this.o4v_1 = ContentType().p4u('application', 'vnd.openxmlformats-officedocument.wordprocessingml.document');
        this.p4v_1 = ContentType().p4u('application', 'vnd.openxmlformats-officedocument.presentationml.presentation');
        this.q4v_1 = ContentType().p4u('application', 'protobuf');
        this.r4v_1 = ContentType().p4u('application', 'wasm');
        this.s4v_1 = ContentType().p4u('application', 'problem+json');
        this.t4v_1 = ContentType().p4u('application', 'problem+xml');
      }
      u4v(contentType) {
        return startsWith(contentType, 'application/', true);
      }
    }
    initMetadataForObject($, 'Application');
    ApplicationClass = $;
  }
  return ApplicationClass;
}
var Application_instance;
function Application_getInstance() {
  if (Application_instance === VOID)
    new (Application())();
  return Application_instance;
}
var MultiPartClass;
function MultiPart() {
  if (MultiPartClass === VOID) {
    class $ {
      constructor() {
        MultiPart_instance = this;
        this.v4v_1 = 'multipart';
        this.w4v_1 = ContentType().p4u('multipart', '*');
        this.x4v_1 = ContentType().p4u('multipart', 'mixed');
        this.y4v_1 = ContentType().p4u('multipart', 'alternative');
        this.z4v_1 = ContentType().p4u('multipart', 'related');
        this.a4w_1 = ContentType().p4u('multipart', 'form-data');
        this.b4w_1 = ContentType().p4u('multipart', 'signed');
        this.c4w_1 = ContentType().p4u('multipart', 'encrypted');
        this.d4w_1 = ContentType().p4u('multipart', 'byteranges');
      }
      u4v(contentType) {
        return startsWith(contentType, 'multipart/', true);
      }
    }
    initMetadataForObject($, 'MultiPart');
    MultiPartClass = $;
  }
  return MultiPartClass;
}
var MultiPart_instance;
function MultiPart_getInstance() {
  if (MultiPart_instance === VOID)
    new (MultiPart())();
  return MultiPart_instance;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ {
      constructor() {
        Text_instance = this;
        this.e4w_1 = 'text';
        this.f4w_1 = ContentType().p4u('text', '*');
        this.g4w_1 = ContentType().p4u('text', 'plain');
        this.h4w_1 = ContentType().p4u('text', 'css');
        this.i4w_1 = ContentType().p4u('text', 'csv');
        this.j4w_1 = ContentType().p4u('text', 'html');
        this.k4w_1 = ContentType().p4u('text', 'javascript');
        this.l4w_1 = ContentType().p4u('text', 'vcard');
        this.m4w_1 = ContentType().p4u('text', 'xml');
        this.n4w_1 = ContentType().p4u('text', 'event-stream');
      }
    }
    initMetadataForObject($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var Text_instance;
function Text_getInstance() {
  if (Text_instance === VOID)
    new (Text())();
  return Text_instance;
}
var ContentTypeClass;
function ContentType() {
  if (ContentTypeClass === VOID) {
    class $ extends HeaderValueWithParameters() {
      constructor(contentType, contentSubtype, existingContent, parameters) {
        return new.target.o4w(contentType, contentSubtype, existingContent, parameters);
      }
      static o4w(contentType, contentSubtype, existingContent, parameters) {
        Companion_getInstance();
        parameters = parameters === VOID ? emptyList() : parameters;
        var $this = this.p4w(existingContent, parameters);
        $this.n4u_1 = contentType;
        $this.o4u_1 = contentSubtype;
        return $this;
      }
      static p4u(contentType, contentSubtype, parameters) {
        Companion_getInstance();
        parameters = parameters === VOID ? emptyList() : parameters;
        return this.o4w(contentType, contentSubtype, contentType + '/' + contentSubtype, parameters);
      }
      q4w(name, value) {
        if (hasParameter(this, name, value))
          return this;
        return ContentType().o4w(this.n4u_1, this.o4u_1, this.f4u_1, plus(this.g4u_1, HeaderValueParam().r4w(name, value)));
      }
      s4w() {
        return this.g4u_1.n1() ? this : ContentType().p4u(this.n4u_1, this.o4u_1);
      }
      t4w(pattern) {
        if (!(pattern.n4u_1 === '*') && !equals(pattern.n4u_1, this.n4u_1, true)) {
          return false;
        }
        if (!(pattern.o4u_1 === '*') && !equals(pattern.o4u_1, this.o4u_1, true)) {
          return false;
        }
        var _iterator__ex2g4s = pattern.g4u_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.r1();
          var patternName = _destruct__k2r9zo.ze();
          var patternValue = _destruct__k2r9zo.af();
          var tmp;
          if (patternName === '*') {
            var tmp_0;
            if (patternValue === '*') {
              tmp_0 = true;
            } else {
              var tmp0 = this.g4u_1;
              var tmp$ret$0;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var tmp_1;
                if (isInterface(tmp0, Collection())) {
                  tmp_1 = tmp0.n1();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp$ret$0 = false;
                  break $l$block_0;
                }
                var _iterator__ex2g4s_0 = tmp0.p1();
                while (_iterator__ex2g4s_0.q1()) {
                  var element = _iterator__ex2g4s_0.r1();
                  if (equals(element.i4u_1, patternValue, true)) {
                    tmp$ret$0 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$0 = false;
              }
              tmp_0 = tmp$ret$0;
            }
            tmp = tmp_0;
          } else {
            var value = this.u4w(patternName);
            tmp = patternValue === '*' ? !(value == null) : equals(value, patternValue, true);
          }
          var matches = tmp;
          if (!matches) {
            return false;
          }
        }
        return true;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof ContentType()) {
          tmp_1 = equals(this.n4u_1, other.n4u_1, true);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(this.o4u_1, other.o4u_1, true);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(this.g4u_1, other.g4u_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = this.n4u_1.toLowerCase();
        var result = getStringHashCode(tmp$ret$0);
        var tmp = result;
        var tmp_0 = imul(31, result);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = this.o4u_1.toLowerCase();
        result = tmp + (tmp_0 + getStringHashCode(tmp$ret$2) | 0) | 0;
        result = result + imul(31, hashCode(this.g4u_1)) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'ContentType');
    ContentTypeClass = $;
  }
  return ContentTypeClass;
}
function charset(_this__u8e3s4) {
  _init_properties_ContentTypes_kt__i9dj34();
  var tmp0_safe_receiver = _this__u8e3s4.u4w('charset');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    try {
      tmp_0 = forName(Charsets_getInstance(), tmp0_safe_receiver);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException()) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function withCharset(_this__u8e3s4, charset) {
  _init_properties_ContentTypes_kt__i9dj34();
  return _this__u8e3s4.q4w('charset', get_name(charset));
}
var BadContentTypeFormatExceptionClass;
function BadContentTypeFormatException() {
  if (BadContentTypeFormatExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(value) {
        return new.target.v4u(value);
      }
      static v4u(value) {
        var $this = this.xd('Bad Content-Type format: ' + value);
        captureStack($this, $this.u4u_1);
        return $this;
      }
    }
    initMetadataForClass($, 'BadContentTypeFormatException');
    BadContentTypeFormatExceptionClass = $;
  }
  return BadContentTypeFormatExceptionClass;
}
function withCharsetIfNeeded(_this__u8e3s4, charset) {
  _init_properties_ContentTypes_kt__i9dj34();
  var tmp;
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  if (!(_this__u8e3s4.n4u_1.toLowerCase() === 'text')) {
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4.q4w('charset', get_name(charset));
  }
  return tmp;
}
var properties_initialized_ContentTypes_kt_1k2nnm;
function _init_properties_ContentTypes_kt__i9dj34() {
  if (!properties_initialized_ContentTypes_kt_1k2nnm) {
    properties_initialized_ContentTypes_kt_1k2nnm = true;
    textSubTypes = setOf(['json', 'ld+json', 'xml', 'xhtml+xml', 'rss+xml', 'atom+xml', 'x-www-form-urlencoded', 'svg+xml']);
  }
}
//region block: exports
export {
  Application_getInstance as Application_getInstance17ubdrb0i0ohu,
  Companion_getInstance as Companion_getInstance3eu9tsw6r4gc4,
  MultiPart_getInstance as MultiPart_getInstance1k6b6wx1k1sjr,
  Text_getInstance as Text_getInstancecnzpw4phsgym,
  ContentType as ContentType1svlpabm9v7iz,
  charset as charset1dribv3ku48b1,
  withCharsetIfNeeded as withCharsetIfNeeded3sz33ys0x9vfx,
  withCharset as withCharset27k3t3dvzhi4n,
};
//endregion

//# sourceMappingURL=ContentTypes.mjs.map
